import { UserManager, Log } from "oidc-client-ts";
import { oidcConfig } from "./config";

Log.setLogger(console);
Log.setLevel(Log.DEBUG);

export const oidcUserManager = new UserManager(oidcConfig);